<template>
  <div class="fc">系统升级中，敬请期待......</div>
</template>

<script>
export default {
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
div {
  width: 100vw;
  height: calc(80vh - 80px);
  padding-bottom: 20vh;
  font-size: 22px;
  color: #666;
  background: #efeaea;
}
</style>
